<template>
  <svg
    class="w-4 h-4"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="#023E73"
    viewBox="0 0 22 22"
  >
    <path
      fill-rule="evenodd"
      d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: "IconBin",
};
</script>

<style scoped>
/* Optional scoped styles for IconCircle component */
</style>
